import { ContactType } from '../../contact/contact.type';
import { ScimScope } from './scim.scope';

export const SCIM_SCOPE_CONTACT_TYPE: Record<ScimScope, ContactType> = {
    [ScimScope.Employee]: ContactType.Employee,
    [ScimScope.Customer]: ContactType.LoginContact,
    [ScimScope.Contractor]: ContactType.LoginContact,
};
